import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/lib/Async';
import CreatableSelect from 'react-select/lib/Creatable';
import SelectService from '../../../services/SelectService';

import Alert from '../../../shared/components/Alert';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class BatchUpdateModal extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    modal: PropTypes.bool,
    locationID: PropTypes.string,
    toggle: PropTypes.func.isRequired,
    postValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    color: 'primary',
    modal: false,
    locationID: '',
    postValue: {},
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
    errorMsg: '',
  };

  constructor(props) {
    super(props);
    const { postValue } = this.props;
    this.userData = JSON.parse(localStorage.getItem('userData'));
    this.state = {
      modal: false,
      rooms: [],
      myformdata: {},
      grandTotal: 0,
    };

    this.isLoading = false;
    this.currrentbatchid = postValue.batch_id;
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    this.getRooms();
    this.getProducts();
    this.onLoadInventory();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.modal) {
      const { postValue } = this.props;

      if (postValue.batch_id !== nextProps.postValue.batch_id) {
        const newprops = nextProps.postValue.batch_id;
        this.currrentbatchid = newprops;
      }

      this.onLoadInventory();
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadInventory = async () => {
    try {
       const response = await CommonService.getRows(`getinventoryentry/batchid/${this.currrentbatchid}`);
       if (response.result !== false) {
        this.setState({ myformdata: response.data, grandTotal: response.data.balance_new * response.data.unit_cost });
       }
    } catch (err) {
       console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  getProducts = async (newValue) => {
    const dataForm = { searchFor: newValue };
    const options = [];
    this.isLoading = true;
    if (this.isLoading) {
      await SelectService.listProductOptions(dataForm).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.product_id,
              label: opt.product_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }
    this.isLoading = false;
    this.setState({ products: options });
  }

  getSuppliers = async (newValue) => {
    const dataForm = { searchFor: newValue };
    const options = [];
    this.isLoading = true;
    if (this.isLoading) {
      await SelectService.listSupplierOptions(dataForm).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.supplier_id,
              label: opt.supplier_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }

    this.isLoading = false;
    return options;
  }

  getRooms = async (newValue) => {
    const { locationID } = this.props;
    const dataForm = { searchFor: newValue, locationid: locationID };
    const options = [];
    this.isLoading = true;
    if (this.isLoading) {
      await SelectService.listRoomOptions(dataForm).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.value,
              label: opt.label,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }
    this.isLoading = false;
    this.setState({ rooms: options });
  }

  handleMyChanges = (e, fieldName) => {
    if (fieldName === 'product') {
      if (e && e !== null) {
        this.setState(prevState => ({
          myformdata: { ...prevState.myformdata, product_id: e.value, product_name: e.label },
        }));
      } else {
        this.setState(prevState => ({
          myformdata: { ...prevState.myformdata, product_name: undefined, product_id: undefined },
        }));
      }
    } else if (fieldName === 'supplier') {
      if (e && e !== null) {
        this.setState(prevState => ({
          myformdata: { ...prevState.myformdata, supplier_id: e.value, supplier_name: e.label },
        }));
      } else {
        this.setState(prevState => ({
          myformdata: { ...prevState.myformdata, supplier_name: undefined, supplier_id: undefined },
        }));
      }
    } else if (fieldName === 'room') {
      if (e && e !== null) {
        this.setState(prevState => ({
          myformdata: { ...prevState.myformdata, room_name: e.value },
        }));
      } else {
        this.setState(prevState => ({
          myformdata: { ...prevState.myformdata, room_name: undefined },
        }));
      }
    } else if (fieldName === 'date') {
      const date = new Date(e);
      this.setState(prevState => ({
        myformdata: { ...prevState.myformdata, date_received: date },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        myformdata: { ...prevState.myformdata, [name]: value },
      }));
    }
  }

  changeMyTotal = (e, fieldName) => {
    const { myformdata } = this.state;
    const ret = global.numbersonly(e);
    console.log(e.target.value);
    const numberEntered = parseFloat(e.target.value, 10);
    let gTotal = 0;
    const evalue = e.target.value.replace(/[^0-9.]/g, '');

    if (!ret) {
      e.target.value = evalue;
    }

    if (fieldName === 'quantity') {
      gTotal = myformdata.unit_cost * (numberEntered - myformdata.balance_var);
      this.setState(prevState => ({
        myformdata: { ...prevState.myformdata, quantity: evalue },
      }));
    } else if (fieldName === 'unit') {
      gTotal = (myformdata.quantity - myformdata.balance_var) * numberEntered;
    }

    this.setState({ grandTotal: gTotal });
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      rooms, products, myformdata, grandTotal,
    } = this.state;

    const {
      color, modal, toggle, handleSubmit, errorMsg,
    } = this.props;
    const selectedDate = new Date(myformdata.date_received);

    const dataQuantity = myformdata.quantity !== '' ? myformdata.quantity : 0;
    const dataUnitCost = myformdata.unit_cost !== '' ? myformdata.unit_cost : 0;
    const newDatabalance = global.numberFormat(dataQuantity - myformdata.balance_var, 0);
    const finalTotalValue = grandTotal !== 0 ? grandTotal : newDatabalance * dataUnitCost;

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">Update Batch</h4>
          </div>
          <form id="updateInventory_form" onSubmit={handleSubmit}>
            <div className="modal__body">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Reference No.:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="reference_number" placeholder="Reference No." value={myformdata.reference_number ? myformdata.reference_number : ''} onChange={e => this.handleMyChanges(e)} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Product Name:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <CreatableSelect
                      name="product_name"
                      options={products}
                      className="react-select"
                      classNamePrefix="react-select"
                      placeholder="Select product"
                      value={[{ label: myformdata.product_name, value: myformdata.product_id }]}
                      onChange={e => this.handleMyChanges(e, 'product')}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Batch Code:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="batch_code" placeholder="Product batch code..." value={myformdata.batch_code ? myformdata.batch_code : ''} onChange={e => this.handleMyChanges(e)} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Supplier:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                  <AsyncSelect
                    name="supplier"
                    cacheOptions
                    loadOptions={this.getSuppliers}
                    defaultOptions
                    className="react-select"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    value={[{ label: myformdata.supplier_name, value: myformdata.supplier_id }]}
                    onChange={e => this.handleMyChanges(e, 'supplier')}
                  />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Delivery Date:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <div className="date-picker">
                      <DatePicker
                        name="delivery_date"
                        selected={myformdata.date_received ? selectedDate : new Date()}
                        onChange={e => this.handleMyChanges(e, 'date')}
                      />
                    </div>
                    <div className="form__form-group-icon">
                      <i className="fa fa-calendar-alt" />
                    </div>
                  </div>
                </div>
                <div className="form__form-group m-b-35">
                  <span className="form__form-group-label">Room Number:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <CreatableSelect
                      name="room_number"
                      options={rooms}
                      className="react-select"
                      classNamePrefix="react-select"
                      placeholder="Enter room"
                      value={[{ label: myformdata.room_name, value: myformdata.room_name }]}
                      onChange={e => this.handleMyChanges(e, 'room')}
                    />
                  </div>
                </div>
                <div className="form__form-group m-b-5">
                  <span className="form__form-group-label">Received Quantity:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="received_quantity" defaultValue={dataQuantity} placeholder="Received quantity..." onChange={e => this.changeMyTotal(e, 'quantity')} />
                  </div>
                </div>
                <div className="form__form-group m-b-5">
                  <span className="form__form-group-label">Actual Quantity:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <span className={`full-width text-right fs-20 bold ${newDatabalance <= 0 ? 'text-red' : ''}`}>{newDatabalance} kgs.</span>
                  </div>
                </div>
                <div className={`form__form-group m-b-5 ${(['1', '6'].indexOf(this.userData.type) > -1) === false ? ' display-none' : ''}`}>
                  <span className="form__form-group-label">Unit Price:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="unit_price" defaultValue={dataUnitCost} placeholder="Unit price..." onChange={e => this.changeMyTotal(e, 'unit')} />
                  </div>
                </div>
                <div className={`form__form-group m-b-5 ${(['1', '6'].indexOf(this.userData.type) > -1) === false ? ' display-none' : ''}`}>
                  <span className="form__form-group-label">Total:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <span className={`full-width text-right fs-20 bold ${finalTotalValue <= 0 ? 'text-red' : ''}`}>&#x20b1; {global.numberFormat(finalTotalValue)}</span>
                  </div>
                </div>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color={color}>Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'warehouse_insertInventory', // a unique identifier for this form
})(withTranslation('common')(BatchUpdateModal));
